exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".report-table {\n  font-size: 0.825em; }\n", ""]);

// exports
